import { createBrowserHistory } from 'history';

export const historyBrowser = createBrowserHistory();

export const setAuthData = (data) => {
    console.log('Auth data is was set: ' + data);
    sessionStorage.setItem('CryptoID', encodeString(JSON.stringify(data)))
};

export const getAuthData = () => {
    if(sessionStorage.getItem('CryptoID')){
        return JSON.parse(decodeString(sessionStorage.getItem('CryptoID')))
    } else {
        // logout();
        return null;
    }
}

export const encodeString = (str) => window.btoa(unescape(encodeURIComponent(str)));

export const decodeString = (str) => decodeURIComponent(escape(window.atob(str)));

export const getUsername = () => getAuthData()[1];

export const getUserId = () => getAuthData()[2];

export const getUserRole = () => decodeString(getAuthData()[3]);

export const logout = (historyRouter = false) => {
    sessionStorage.removeItem('CryptoID');
    historyRouter ? historyRouter.push('/') : historyBrowser.push('/');
};

export const checkAuth = (error, history) => {
    if ((error && error.status === 401) || (error && error.response.status === 401)) {
        console.log('auth false');
        logout(history);
    }
};

export const getAuthToken = () => {
    const authData = getAuthData();
    if (authData === null) {
        sessionStorage.removeItem('CryptoID');
        return null;
    }
    return authData[0];
};

export const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};


// WEBPACK FOOTER //
// ./src/utils.js